export const version = "1.0.0";

export const accountId = "";

export const env = "prod";

export const firebaseConfig = {
  apiKey: "AIzaSyAsC3izJjfkvkjVnJalSypbiaQZ22vlQIc",
  authDomain: "dls-platform-prod.firebaseapp.com",
  projectId: "dls-platform-prod",
  storageBucket: "dls-platform-prod.appspot.com",
  messagingSenderId: "396063393921",
  appId: "1:396063393921:web:340cd27b8c25d360ada580",
  measurementId: "G-K317C5JHHP"
};

export const reduxFirebase = {
  enableLogging: "false",
};

export const atlas = {
  serverUrl: "http://localhost:5001/axon-platform/us-central1",
};

export const build = {
  baseUrl: "http://localhost:3100",
};

export const sdk = {
  baseUrl: "https://localhost:9000",
};

export const configs = {
  baseUrl: "https://axon-config.ngrok.io",
};

export const customer = {
  activityStreamTopicName: "customer-activity",
};

export const agent = {
  ipStackAPIAccessKey: "4d1a98985ea36c7d938ee42f111441bf",
};

export default { version, accountId, env, firebaseConfig, reduxFirebase, atlas, build, sdk, configs, customer, agent };
